// extracted by mini-css-extract-plugin
module.exports = {"footerTag":"_3Lk6m","footerLink":"_3tvq5","footerTitle":"_1YW0Q","wrapper":"_1fGOv","copyright":"_1dKBp","bottomNavbarFooter":"_1f1hJ"};